import qs from 'qs'
import request from '@/utils/request'

// ============================================================
// 政企实训管理端接口封装
// 后端统一约定：POST + 表单参数（@RequestParam），故全部使用 qs.stringify
// 鉴权：除登录外，请求头由 request.js 自动携带 userzqsx（登录返回的 aesUser 凭证）
// 注：zqsx 模块的鉴权头为 userzqsx，区别于其他业务的 useraxj
// ============================================================

// ==================== 认证 ====================

// 管理端登录（手机号 + 密码，返回含 aesUser 凭证的用户信息）
export function doLogin (data) {
  return request({ url: '/zqsx-auth-user/doLogin', method: 'post', data: qs.stringify(data) })
}

// 获取当前用户所属项目记录列表（登录后切换项目用）
export function getZqsxAuthUserProjectList (data) {
  return request({ url: '/zqsx-auth-user/getZqsxAuthUserProjectList', method: 'post', data: qs.stringify(data) })
}

// ==================== 用户管理 ====================

// 用户列表（分页，支持姓名/账号/岗位筛选；项目管理员仅查所属项目用户）
export function getZqsxAuthUserList (data) {
  return request({ url: '/zqsx-auth-user/getZqsxAuthUserList', method: 'post', data: qs.stringify(data) })
}

// 新增用户（zauPw 明文传入，后端加密存储）
export function addZqsxAuthUser (data) {
  return request({ url: '/zqsx-auth-user/addZqsxAuthUser', method: 'post', data: qs.stringify(data) })
}

// 编辑用户（zauPw 为空则不修改密码）
export function updateZqsxAuthUser (data) {
  return request({ url: '/zqsx-auth-user/updateZqsxAuthUser', method: 'post', data: qs.stringify(data) })
}

// 删除用户（逻辑删除）
export function deleteZqsxAuthUser (data) {
  return request({ url: '/zqsx-auth-user/deleteZqsxAuthUser', method: 'post', data: qs.stringify(data) })
}

// 重置用户密码
export function resetZqsxAuthUserPw (data) {
  return request({ url: '/zqsx-auth-user/resetZqsxAuthUserPw', method: 'post', data: qs.stringify(data) })
}

// ==================== 项目管理（增删改仅系统管理员） ====================

// 项目列表（分页，系统管理员查全部，项目管理员仅查所属）
export function getZqsxAuthProjectList (data) {
  return request({ url: '/zqsx-auth-project/getZqsxAuthProjectList', method: 'post', data: qs.stringify(data) })
}

// 新增项目
export function addZqsxAuthProject (data) {
  return request({ url: '/zqsx-auth-project/addZqsxAuthProject', method: 'post', data: qs.stringify(data) })
}

// 编辑项目
export function updateZqsxAuthProject (data) {
  return request({ url: '/zqsx-auth-project/updateZqsxAuthProject', method: 'post', data: qs.stringify(data) })
}

// 删除项目
export function deleteZqsxAuthProject (data) {
  return request({ url: '/zqsx-auth-project/deleteZqsxAuthProject', method: 'post', data: qs.stringify(data) })
}

// ==================== 模块管理（内容管理：8大菜单及分级窗口配置） ====================

// 模块列表（分页，按父级 zmParentId 查询子级；项目管理员仅查所属项目）
export function getZqsxModelList (data) {
  return request({ url: '/zqsx-model/getZqsxModelList', method: 'post', data: qs.stringify(data) })
}

// 新增模块（根据 zmLayoutSelf 1列表/2网格/3内容 校验不同字段）
export function addZqsxModel (data) {
  return request({ url: '/zqsx-model/addZqsxModel', method: 'post', data: qs.stringify(data) })
}

// 编辑模块
export function updateZqsxModel (data) {
  return request({ url: '/zqsx-model/updateZqsxModel', method: 'post', data: qs.stringify(data) })
}

// 删除模块（递归软删自身及所有子模块）
export function deleteZqsxModel (data) {
  return request({ url: '/zqsx-model/deleteZqsxModel', method: 'post', data: qs.stringify(data) })
}

// 导出模块导入模板（返回 Excel 文件流，用于填写后批量导入证书）
export function exportZqsxModelTemplate () {
  return request({
    url: '/zqsx-model/exportZqsxModelTemplate',
    method: 'post',
    responseType: 'blob'
  })
}

// 批量导入证书（file 走 formData，zmParentId 走 URL query 参数）
// 返回：{ total, successCount, failCount, list }
export function importZqsxModelCer (data) {
  const { file, zmParentId } = data
  const formData = new FormData()
  formData.append('file', file)
  // zmParentId 为后端 @RequestParam，拼接为 URL query 参数；为空则不传（导入为一级模块）
  const params = {}
  if (zmParentId !== undefined && zmParentId !== null && zmParentId !== '') {
    params.zmParentId = zmParentId
  }
  return request({
    url: '/zqsx-model/importZqsxModelCer',
    method: 'post',
    data: formData,
    params
  })
}

// ==================== 文件上传 ====================

// 上传文件到腾讯云对象存储（FormData，字段名 file；返回 data 为文件可访问 URL）
export function uploadFile (data) {
  return request({ url: '/tx-cloud-file/uploadFileToTxCloudEquityAjTools', method: 'post', data })
}
